module.exports = __webpack_public_path__ + "static/media/video3.0aa44780.mp4";